import { render, staticRenderFns } from "./post-teaser.vue?vue&type=template&id=63709888&scoped=true&"
import script from "./post-teaser.vue?vue&type=script&lang=js&"
export * from "./post-teaser.vue?vue&type=script&lang=js&"
import style0 from "./post-teaser.vue?vue&type=style&index=0&id=63709888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63709888",
  null
  
)

export default component.exports